module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAV1BMVEUAAAB2kft1kPt0kPlxi/N1kfp2kfp1kPp0kPtJev92kfpwivh2kfp2kPp2kfp1kfp1kfp0kPlzkPt2kfp1kft2kft2jvpggP92kfx1kPl1j/tzkvl2kfpLBI74AAAAHHRSTlMA8aw/EenKn2EEeBv54NCibFM62b2MNAiVg0wqfhC83AAAAKJJREFUGNN1j+sOgzAIhWlttbXede7G+z/ngLNlJsbvD18OKQW6pO3DKbv3nAiUSlAJnjkuCJ/M7KT6jpXaJjzEolTHRlc09GKr1DxH6c6ZlE3fmFXMO4FBwg0apQl6CT20FFR80Ki8GiFgYxZudo/ajumqrVpCWxlV7Y63rZkyZXuzklGz4mqcMSNc+MBIX6Z/5jP9SA6Rm+hAmPwwjCnQNR9gVQ8wWxRu5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/activation_xuefei.png
// module id = Kt9A
// module chunks = 57